import React, { useState, useEffect } from "react"

import BtnSave from "../../../Components/Commons/Buttons/BtnSave"
import BtnDelete from "../../Commons/Buttons/BtnDelete"
import AntDTable from "../../AntDTable/AntDTable"
import BtnAdd from "../../Commons/Buttons/BtnAdd"
import AdjustPrescriptionModal from "./AdjustPrescriptionModal"
import DeleteModal from "../../Modals/DeleteModal"

import { validateTherapeuticsArrayObjects } from "../../../Components/Helpers/Utilities/Validations/ArrayObjectValidation"
import { Row, Col } from "react-bootstrap"
import { Button, Divider, Input, AutoComplete, Form } from "antd"
import { getPrescriptionTemplates } from "../../Helpers/API/PrescriptionApi/PrescriptionApi"
import { RefreshRounded } from "@mui/icons-material"
import {
  createTherapeutic,
  deleteTherapeutic,
  getTherapeutic,
  getTherapeutics,
  updateTherapeutic,
  getAutoSuggestTherapeutics,
} from "../../Helpers/API/CheckUpApi/CheckUpApi"
import { toast } from "react-toastify"
import { flattenPrescriptionRows, getRole } from "../../Helpers/Utilities/Common"

const { TextArea } = Input

function Therapeutics({ patientId, assessmentId, setSelectedCheckUpTab }) {
  const role = getRole()
  const [data, setData] = useState([])
  const [prescriptionTemplates, setPrescriptionTemplates] = useState([])
  const [prescriptionDetails, setPrescriptionDetails] = useState([])
  const [autoSuggestData, setAutoSuggestData] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [showView, setShowView] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [selectedPrescriptionRow, setSelectedPrescriptionRow] = useState({})
  const [selectedRow, setSelectedRow] = useState({})
  const [showEdit, setShowEdit] = useState(false)
  const [searchPrescription, setSearchPrescription] = useState("")
  const newPrescription = {
    generic: "",
    brand: "",
    dosage: "",
    preparation: "",
    quantity: "",
    duration: "",
    instruction: "",
    note: "",
    // form: "",
    // route: "",
    // frequency: "",
    // timing: "",
  }
  const [therapeuticForm, setTherapeuticForm] = useState([newPrescription])

  // Function remove row of therapeutic form
  const handleRemoveRow = (index) => {
    var _therapeuticForm = [...therapeuticForm]
    _therapeuticForm.splice(index, 1)
    setTherapeuticForm(() => _therapeuticForm)
  }

  // Function for handling values therapeutic form
  const handleChange = (e, index, type) => {
    setAutoSuggestData([])
    if (type) {
      var selectForm = [...therapeuticForm]
      selectForm[index][type] = e

      setTherapeuticForm(() => selectForm)
    } else {
      const { name, value } = e.target
      var _therapeuticForm = [...therapeuticForm]
      _therapeuticForm[index][name] = value

      setTherapeuticForm(() => _therapeuticForm)
    }
  }
  const handleSearch = (e, type) => {
    if (type) {
      fetchAutoSuggestTherapeutics(type, e)
    }
  }

  // Function for adding action button in table
  function ActionBtn(row) {
    return (
      <Row className="center">
        <Col>
          <BtnSave
            id={"green-btn"}
            label={"Edit"}
            size={"sm"}
            onClick={(e) => {
              setShowEdit(true)
              setSelectedPrescriptionRow(row.row)
              setTherapeuticForm(() => [row.row])
            }}
          />
        </Col>
        <Col>
          <BtnDelete
            label={"Remove"}
            size={"sm"}
            onClick={(e) => {
              setShowDelete(true)
              setSelectedRow(row.row)
            }}
          />
        </Col>
        {/* {
          role === "director" || role === "pcp" || role === "specialist" && (
            <Col>
              <BtnDelete
                label={"Remove"}
                size={"sm"}
                onClick={(e) => {
                  setShowDelete(true);
                  setSelectedRow(row.row);
                }}
              />
            </Col>
          )
        } */}
      </Row>
    )
  }

  // Function for adding another therapeutic form
  function PrescriptionBtn(row) {
    return (
      <Row className="center prescribe-button-container">
        <Col>
          <BtnSave
            id={"green-btn"}
            label={"Prescribe"}
            size={"sm"}
            onClick={(e) => {
              console.log(row)
              setSelectedPrescriptionRow(() => {
                return { ...row.row }
              })
              // Only show the current prescription being added, not previous ones
              setPrescriptionDetails([{ ...row.row }])
              setShowView(true)
            }}
          />
        </Col>
      </Row>
    )
  }

  // Function create therapeutic API
  async function submitTherapeutic(prescriptionDetails) {
    setIsClicked(true)
    const res = await createTherapeutic(
      prescriptionDetails,
      patientId,
      assessmentId
    )
    if (res.data) {
      toast.success(res.data.message)
      setShowView(false)
      fetchPrescriptionTemplates()
      fetchPatientTherapeutics()
      setTherapeuticForm(() => [newPrescription]) // reset form
       if (typeof setSelectedCheckUpTab === "function") {
        setSelectedCheckUpTab("out_patient");
      }
    } else if (res.error) {
      res?.error?.data.messages?.error_messages?.forEach((errMsg) => {
        toast.error(errMsg)
      })
    }
    setIsClicked(false)
  }

  // Function edit therapeutic API
  async function editTherapeutic(prescriptionDetails) {
    setIsClicked(true)
    const res = await updateTherapeutic(
      prescriptionDetails,
      patientId,
      assessmentId,
      setSelectedPrescriptionRow.id
    )
    if (typeof setSelectedCheckUpTab === "function") {
      setSelectedCheckUpTab("out_patient");
    }
    if (res.data) {
      toast.success(res.data.message)
      fetchPrescriptionTemplates()
      fetchPatientTherapeutics()
      setShowEdit(false)
      setTherapeuticForm(() => [newPrescription])
    } else if (res.error) {
    }
    setIsClicked(false)
  }

  // Function remove therapeutic API
  async function removeTherapeutic() {
    setIsClicked(true)
    const res = await deleteTherapeutic(selectedRow.id)
    if (res.data) {
      toast.success(res.data.message)
      setShowDelete(false)
      fetchPatientTherapeutics()
    } else if (res.error) {
    }
    setIsClicked(false)
  }

  // Function get prescription template API
  async function fetchPrescriptionTemplates() {
    const res = await getTherapeutic({ search: searchPrescription })

    if (res.data) {
      const flattenedDetails = flattenPrescriptionRows(res.data)
        .map((row) => ({
          ...row,
          prescription_template_id: row?.prescription_id ?? row?.id ?? null,
        }))
      setPrescriptionTemplates(flattenedDetails)
    } else if (res.error) {
    }
  }

  // Function get therapeutic API
  async function fetchPatientTherapeutics() {
    setShowLoader(true)
    const res = await getTherapeutics({
      patient_id: patientId,
      assessment_id: assessmentId,
    })

    if (res.data) {
      setData(res.data)
    } else if (res.error) {
      setData([])
    }
    setShowLoader(false)
  }

  // Function get therapeutics of the patient API
  // async function fetchPreviousTherapeutics() {
  //   setShowLoader(true);
  //   const res = await getTherapeutic({
  //     patient_id: patientId,
  //     previous_therapeutic: "1",
  //   });
  //   if (res.data) {
  //     setTherapeuticForm(res.data);
  //   } else if (res.error) {
  //     setTherapeuticForm([newPrescription]);
  //   }
  // }

  // Function get therapeutic API
  async function fetchAutoSuggestTherapeutics(type, data) {
    setShowLoader(true)
    const response = await getAutoSuggestTherapeutics({
      table: "therapeutic",
      field: type,
      term: data,
    })

    if (response.data) {
      setAutoSuggestData(
        response?.data?.data?.map((data) => ({ label: data, value: data }))
      )
    } else {
      setAutoSuggestData([])
    }
    setShowLoader(false)
  }

  // Function handle for save or edit therapeutic
  const handleSavePrescription = () => {
    if (therapeuticForm[0].id) {
      editTherapeutic(therapeuticForm[0])
    } else {
      submitTherapeutic(therapeuticForm)
    }
  }

  function handlePrescriptionChange(e) {
    setSearchPrescription(e)
  }

  const handleEmptySearch = (e) => {
    if (e.target.value === "") {
      setSearchPrescription("")
    }
  }

  useEffect(() => {
    if (searchPrescription !== "") {
      fetchPrescriptionTemplates()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPrescription])

  useEffect(() => {
    fetchPatientTherapeutics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentId])

  // useEffect(() => {
  //   fetchPreviousTherapeutics();
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <Row className="therapeautics-container-three">
      <Row>
        <Row>
          <Col
            className="therapeutics"
            style={{
              backgroundColor: "#F0F0F3",
              borderRadius: 10,
              marginRight: 3,
            }}
          >
            <div className="row pt-4 prescription-containers">
              <h6 className="font-bold">
                Prescriptions
                <span>
                  <Button
                    type="text"
                    onClick={fetchPrescriptionTemplates}
                    icon={<RefreshRounded />}
                  />
                </span>
              </h6>
              <div className="col-8 pt-1 mb-2 d-flex justify-content-start">
                <Input.Search
                  placeholder="Search Generic/Brand"
                  allowClear
                  size="medium"
                  // value={searchPrescription}
                  // onChange={(e) => handlePrescriptionChange(e.target.value)}
                  onSearch={(e) => handlePrescriptionChange(e)}
                  onChange={(e) => handleEmptySearch(e)}
                />
              </div>
            </div>
            <AntDTable
              tableHeaders={["GENERIC", "BRAND", "DOSAGE"]}
              headerSelector={["generic", "brand", "dosage"]}
              tableData={prescriptionTemplates}
              isClickable={false}
              ActionBtn={(row) => PrescriptionBtn(row)}
              actionBtnClassName="therapeautics-prescription-button"
              withAction={true}
              scroll={{ x: true }}
              customEmptyText={
                <div className="d-flex flex-column align-items-center">
                  <em className="text-muted my-5">
                    Search for a prescription by <strong>brand</strong> or{" "}
                    <strong>generic name</strong> to view the list.
                  </em>
                </div>
              }
            />
          </Col>
          <Col
            className="therapeutics"
            style={{
              backgroundColor: "#F0F0F3",
              borderRadius: 10,
              marginLeft: 3,
            }}
          >
            <Row className="align-items-center py-4">
              <Col>
                <h6 className="font-bold">
                  {showEdit ? `Edit ` : ""}Therapeutic Form
                </h6>
              </Col>
            </Row>

            {therapeuticForm?.map((data, index) => {
              return (
                <div key={index} className="py-3">
                  <Row>
                    <Col className="therapeutic-each-bar">
                      <Form.Item required label="Generic" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "generic")}
                          onChange={(e) => handleChange(e, index, "generic")}
                          value={data?.generic}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    <Col className="therapeutic-each-bar">
                      <Form.Item label="Brand" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "brand")}
                          onChange={(e) => handleChange(e, index, "brand")}
                          value={data?.brand}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    <Col className="therapeutic-each-bar">
                      <Form.Item label="Dosage" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "dosage")}
                          onChange={(e) => handleChange(e, index, "dosage")}
                          value={data?.dosage}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="therapeutic-each-bar">
                      <Form.Item required label="Preparation" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "preparation")}
                          onChange={(e) =>
                            handleChange(e, index, "preparation")
                          }
                          value={data?.preparation}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    <Col className="therapeutic-each-bar">
                      <Form.Item label="Quantity" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "quantity")}
                          onChange={(e) => handleChange(e, index, "quantity")}
                          value={data?.quantity}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    <Col className="therapeutic-each-bar">
                      <Form.Item label="Duration" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "duration")}
                          onChange={(e) => handleChange(e, index, "duration")}
                          value={data?.duration}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    {/* <Col className="therapeutic-each-bar">
                      <Form.Item label="Form" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "form")}
                          onChange={(e) => handleChange(e, index, "form")}
                          value={data?.form}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col> */}
                    {/* <Col className="therapeutic-each-bar">
                      <Form.Item label="Route" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "route")}
                          onChange={(e) => handleChange(e, index, "route")}
                          value={data?.route}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col> */}
                  </Row>
                  <Row>
                    {/* <Col className="therapeutic-each-bar">
                      <Form.Item label="Frequency" colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "frequency")}
                          onChange={(e) => handleChange(e, index, "frequency")}
                          value={data?.frequency}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col xl={12} className="therapeutic-each-bar">
                      <span>Instruction</span>
                      <Form.Item colon={false}>
                        <AutoComplete
                          options={autoSuggestData}
                          onSearch={(e) => handleSearch(e, "instruction")}
                          onChange={(e) =>
                            handleChange(e, index, "instruction")
                          }
                          value={data?.instruction}
                        >
                          <Input />
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="therapeutic-each-bar">
                      <span>Notes</span>
                      <TextArea
                        rows={4}
                        name="note"
                        value={data?.note}
                        placeholder="Enter your notes here"
                        onChange={(e) => handleChange(e, index)}
                        disabled={isClicked}
                      />
                    </Col>
                  </Row>
                  {therapeuticForm.length > 1 && (
                    <Row className="justify-content-end mt-2">
                      <Col xs={3}>
                        <BtnDelete
                          outline
                          label={`Remove`}
                          onClick={() => handleRemoveRow(index)}
                        />
                      </Col>
                    </Row>
                  )}
                  {therapeuticForm.length !== 1 && <Divider />}
                </div>
              )
            })}

            {/* <Row className="justify-content-end">
              {showEdit && (
                <Col xs={4}>
                  <BtnDelete
                    outline
                    label={"Cancel"}
                    onClick={() => {
                      setShowEdit(false);
                      setTherapeuticForm(() => [newPrescription]);
                    }}
                  />
                </Col>
              )}
              {!showEdit && (
                <Col xs={3}>
                  <BtnAdd
                    label={`+ Add`}
                    onClick={() =>
                      setTherapeuticForm((prev) => [...prev, newPrescription])
                    }
                  />
                </Col>
              )}
              <Col xs={4} className="prescription-btn">
                <BtnSave
                  label={"Save Prescription"}
                  onClick={handleSavePrescription}
                  isClicked={isClicked}
                  disabled={validateTherapeuticsArrayObjects(therapeuticForm)}
                />
              </Col>    
            </Row> */}
            <Row className="align-items-center mb-2">
              <Col xs={12} className="d-flex justify-content-between">
                <div className="col-3">
                  {!showEdit && (
                    <BtnAdd
                      label={`+ Add`}
                      onClick={() =>
                        setTherapeuticForm((prev) => [...prev, newPrescription])
                      }
                    />
                  )}
                  {showEdit && (
                    <BtnDelete
                      outline
                      label={"Cancel"}
                      onClick={() => {
                        setShowEdit(false)
                        setTherapeuticForm(() => [newPrescription])
                      }}
                    />
                  )}
                </div>

                <div className="col-3">
                  <BtnSave
                    label={showEdit ? "Save Changes" : "Submit"}
                    onClick={handleSavePrescription}
                    isClicked={isClicked}
                    disabled={validateTherapeuticsArrayObjects(therapeuticForm)}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-left prescription-containers">
          <Col
            className="therapeutics pt-4 therapeutics-table"
            style={{
              backgroundColor: "#F0F0F3",
              borderRadius: 10,
              marginTop: 6,
            }}
          >
            <AntDTable
              tableHeaders={[
                "GENERIC",
                "BRAND",
                "DOSAGE",
                "PREP",
                "QTY",
                "DURATION",
                "INSTRUCTION",
                "NOTES",
              ]}
              headerSelector={[
                "generic",
                "brand",
                "dosage",
                "preparation",
                "quantity",
                "duration",
                "instruction",
                "note",
              ]}
              tableData={data}
              // loading={showLoader}
              isClickable={false}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              scroll={{ x: true }}
            />
          </Col>
        </Row>
      </Row>

      <AdjustPrescriptionModal
        show={showView}
        onHide={() => setShowView(false)}
        onSubmit={(patientDetails) => submitTherapeutic(patientDetails)}
        prescription={selectedPrescriptionRow}
        prescriptionDetails={prescriptionDetails}
        setPrescriptionDetails={setPrescriptionDetails}
        isClicked={isClicked}
      />
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={"Do you want to delete this therapeutic?"}
        onDelete={removeTherapeutic}
      />
    </Row>
  )
}

export default Therapeutics
